enum MakeModelChatQueueStatus {
    Empty = 1,
    Working = 2,
    Finished = 3
  }
  
  export default MakeModelChatQueueStatus;
